module.exports = __webpack_public_path__ + "static/img/xiaodu-3.a79e066.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xiaodu-3.png
// module id = VWdc
// module chunks = 46